import React from 'react';
import { useState } from 'react';
import { Switch } from '@headlessui/react';

const SwitchInput = ({ setIsVedette, isVedette }) => {
  return (
    <div className=' py-2 flex items-center space-x-2'>
      <Switch
        checked={isVedette}
        onChange={setIsVedette}
        className={`${isVedette ? 'bg-[#1e4ea0]' : 'bg-[#c1c1c1]'}
          relative inline-flex h-[38px] w-[74px] shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white/75`}
      >
        <span
          aria-hidden='true'
          className={`${isVedette ? 'translate-x-9' : 'translate-x-0'}
            pointer-events-none inline-block h-[34px] w-[34px] transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
        />
      </Switch>
      <span className=' font-semibold text-[1.2rem]'>Vedette</span>
    </div>
  );
};

export default SwitchInput;
